import { HomeVideoSearchItem } from "@bluframe/mightychroma-mightytool-frontend-types"

interface Result {
  subtitlePrimary?: string
  subtitleSecondary?: string
}

const getHomeVideoDiscsAndEditions = ({
  editions,
  isBluRay,
  isUHD
}: Pick<HomeVideoSearchItem, "editions" | "isBluRay" | "isUHD">): Result => {
  let subtitlePrimary: Result["subtitlePrimary"]
  if (isBluRay) {
    if (isUHD) {
      subtitlePrimary = "4K UHD Blu-ray"
    } else {
      subtitlePrimary = "Blu-ray"
    }
  }

  let subtitleSecondary: Result["subtitleSecondary"]
  if (editions && editions.length) {
    subtitleSecondary = editions.join(", ")
  }

  return { subtitlePrimary, subtitleSecondary }
}

export default getHomeVideoDiscsAndEditions
